import React, { Component } from 'react';

import STATUSES from '../Components/actionStatuses.json';

export const STATUS_NAMES = Object.keys(STATUSES).reduce(
    (all, statusName) => ({ ...all, [statusName]: statusName }),
    {},
);

export default function ActionsManager(WrappedComponent) {
    return class ActionsManagerComponent extends Component {
        static propTypes = {};

        constructor(props) {
            super(props);

            window.addEventListener('click', this.onOutsideClick);
            document.addEventListener('oitclicked', this.onOutsideClick);

            this.state = { activeAction: '' };
        }

        componentWillUnmount() {
            window.removeEventListener('click', this.onOutsideClick);
            document.removeEventListener('oitclicked', this.onOutsideClick);
        }

        onActionClick = (type) => {
            this.setState({
                activeAction: this.state.activeAction === type ? '' : type,
            });
        };

        onOutsideClick = ({ target }) => {
            const actionsWrapper = $(target).closest('[data-action-buttons]');

            if (!actionsWrapper.length && this.state.activeAction.length) {
                this.setState({ activeAction: '' });
            }
        };

        getActionStatus = type => (this.state.activeAction === type ? STATUS_NAMES.ACTIVE : STATUS_NAMES.NORMAL);

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    actionsManager={{
                        ...this.state,
                        onActionClick: this.onActionClick,
                        getActionStatus: this.getActionStatus,
                    }}
                />
            );
        }
    };
}
